import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { usePageTitle } from "@/lib/usePageTitle";
import { TRADES } from "@/lib/trades";

export default function Trades() {
  usePageTitle("Our Trades — Olivia Does");

  useEffect(() => {
    const hash = window.location.hash.slice(1);
    if (!hash) return;
    const el = document.getElementById(hash);
    if (el) setTimeout(() => el.scrollIntoView({ behavior: "smooth", block: "start" }), 50);
  }, []);

  useEffect(() => {
    const ld = {
      "@context": "https://schema.org", "@type": "ItemList", "name": "Olivia Does Trades & Services",
      "itemListElement": TRADES.map((t, i) => ({ "@type": "ListItem", "position": i + 1, "name": t.name, "url": `${window.location.origin}/trades#${t.slug}` })),
    };
    const id = "od-jsonld-trades-list"; let el = document.getElementById(id);
    if (!el) { el = document.createElement("script"); el.type = "application/ld+json"; el.id = id; document.head.appendChild(el); }
    el.textContent = JSON.stringify(ld);
    return () => { el && el.remove(); };
  }, []);

  return (
    <section className="od-section od-wrap" data-testid="trades-page">
      <div className="od-eyebrow">Our trades</div>
      <h1 className="serif" style={{ fontSize: "2.3rem", fontWeight: 500, margin: "0 0 14px" }}>Everything your home needs, under one roof.</h1>
      <p style={{ color: "var(--taupe)", maxWidth: 620, marginBottom: 40 }}>These are the trades we carry out day in, day out — either with our own team or one of our vetted, insured partners. Tell us what needs doing and we'll scope it, price it and stay on it until it's done properly.</p>

      <div className="ogrid cols-3" data-testid="trades-grid">
        {TRADES.map(({ slug, name, category, Icon, blurb, examples }) => (
          <div key={slug} id={slug} data-testid={`trade-${slug}`} className="tradecard" style={{ display: "flex", flexDirection: "column", scrollMarginTop: 96 }}>
            <Icon className="icon" aria-hidden="true" />
            <h4 style={{ marginTop: 14 }}>{name}</h4>
            <p style={{ color: "var(--taupe)", fontSize: ".9rem", lineHeight: 1.55, margin: "0 0 16px" }}>{blurb}</p>
            <ul style={{ listStyle: "none", padding: 0, margin: "0 0 20px", display: "grid", gap: 6, flex: 1 }}>
              {examples.map((e) => (
                <li key={e} style={{ fontSize: ".86rem", display: "flex", gap: 8, alignItems: "flex-start" }}>
                  <span style={{ color: "var(--rose)", lineHeight: 1.4 }}>·</span>{e}
                </li>
              ))}
            </ul>
            <Link to={`/book?trade=${encodeURIComponent(category)}`} data-testid={`trade-book-${slug}`} className="od-btn-outline" style={{ alignSelf: "flex-start" }}>
              Book {name} <ArrowRight size={15} />
            </Link>
          </div>
        ))}
      </div>

      <div className="card" style={{ marginTop: 40, display: "flex", flexWrap: "wrap", gap: 18, alignItems: "center", justifyContent: "space-between" }} data-testid="trades-other-cta">
        <div>
          <h3 className="serif" style={{ margin: "0 0 6px" }}>Something not on the list?</h3>
          <p>Describe it in your own words and we'll tell you whether — and how — we can help.</p>
        </div>
        <Link to="/book" data-testid="trades-other-book" className="od-btn-primary">Tell us what you need</Link>
      </div>
    </section>
  );
}
